import {
  selOrderVolume,
  tradingVolume,
  selTopShop,
  selOrderFlow,
  getUser,
  selStaffDeptListByParentId
} from '@/api/transaction';

export default {
  namespaced: true,
  actions: {
    // 获取用户信息
    async selOrderVolume(context, params) {
      const { data } = await selOrderVolume(params);
      return data;
    },

    // 交易额趋势
    async tradingVolume(context, params) {
      const { data } = await tradingVolume(params);
      return data;
    },
    // 店铺排行榜
    async selTopShop(context, params) {
      const { data } = await selTopShop(params);
      return data;
    },
    // 交易流动
    async selOrderFlow(context, params) {
      const { data } = await selOrderFlow(params);
      return data;
    },

    // 获取用户信息
    async getUser(context, params) {
      const { data } = await getUser(params);
      return data;
    },

    // 获取用户信息
    async selStaffDeptListByParentId(context, params) {
      const { data } = await selStaffDeptListByParentId(params);
      return data;
    },
  },
};
